import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { MeetingNoteStatus } from './useCalendarEventMeetingNote';

type GenerateMeetingNoteInput =
  | { templateId: string; summarise?: boolean; additionalInstructions?: string }
  | { agendaFileId: string; summarise?: boolean };

type GenerateMeetingNoteResponse = {
  status: MeetingNoteStatus;
  taskId?: string;
  meetingNoteId?: string;
};

export const useGenerateCalendarEventMeetingNote = (eventId: string) => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<{ data: GenerateMeetingNoteResponse }, Error, GenerateMeetingNoteInput>({
    mutationFn: (input: GenerateMeetingNoteInput) =>
      api.post<GenerateMeetingNoteResponse>(`calendar-events/${eventId}/meeting-notes`, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendar-events', eventId, 'meeting-notes'] });
    },
  });

  const generateMeetingNote = async (
    input: GenerateMeetingNoteInput,
  ): Promise<GenerateMeetingNoteResponse> => {
    const result = await mutateAsync(input);
    return result.data;
  };

  return {
    generateMeetingNote,
    isLoading,
    error,
  };
};
